import { render, staticRenderFns } from "./ShowDocumentDetail.vue?vue&type=template&id=7bc5abb3&"
import script from "./ShowDocumentDetail.vue?vue&type=script&lang=ts&"
export * from "./ShowDocumentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports